import { useDispatch, useSelector } from 'react-redux';
import { Filters } from '../interfaces';
import { Client } from './interfaces';
import { deleteClient, exportClients, getClients, getClientsSummary, resetExportClients, setClientDetail, showExportClients } from './actions';
import { ClientsSelectors } from './selectors';

export const useClients = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(ClientsSelectors.getLoading),
    error: useSelector(ClientsSelectors.getError),
    errorInfo: useSelector(ClientsSelectors.getErrorInfo),
    allClients: useSelector(ClientsSelectors.getAllClients),
    clientDetail: useSelector(ClientsSelectors.getClientDetail),
    export: useSelector(ClientsSelectors.getExport),
    summary: useSelector(ClientsSelectors.getSummary),
    getClients: (page?: number, filters?: Filters, rowsPerPage?: number) =>
      dispatch(getClients(page, filters, rowsPerPage)),
    getClientsSummary: (filters?: Filters) => dispatch(getClientsSummary(filters)),
    exportClients: (filters?: Filters, format?: string) => dispatch(exportClients(filters, format)),
    resetExportClients: () => dispatch(resetExportClients()),
    showExportClients: (show: boolean) => dispatch(showExportClients(show)),
    deleteClient: (clientId: number, page?: number, filters?: Filters, rowsPerPage?: number) =>
      dispatch(deleteClient(clientId, page, filters, rowsPerPage)),
    setClientDetail: (client: Client | null) => dispatch(setClientDetail(client)),
  };
};
